define('v3/Pages/Settings/Services/SubjectWebApps.Backend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function WebAppBackend () {
		BackendBase.call(this);
	};

	WebAppBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(WebAppBackend.prototype, {
		getWebApps: function (subjectId, subjectGroupId) {
			if (subjectGroupId) {
				return this._getJsonApi('SubjectWebApps/GetWebApps/' + subjectId + '/' + subjectGroupId);
			} else {
				return this._getJsonApi('SubjectWebApps/GetWebApps/' + subjectId + '/null');
			}
		},
		getSubjects: function () {
			return this._getJsonApi('SubjectWebApps/GetSubjects');
		},
		addWebApp: function (webApp) {
			return this._postApi('SubjectWebApps/AddWebApp', webApp);
		},
		updateWebApp: function (webApp) {
			return this._postApi('SubjectWebApps/UpdateWebApp', webApp);
		},
		deleteWebApp: function (webAppId) {
			return this._postApi('SubjectWebApps/DeleteWebApp/' + webAppId);
		},
		toggleWebApp: function (webApp) {
			return this._postApi('SubjectWebApps/ToggleWebApp', webApp);
		}

	});

	return new WebAppBackend();
});
